export default "__VITE_ASSET__Y_MwZ9e6__"